exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-select-mtr > .list .select-item,\n.list-select-mtr > .list .select-item .v-input__slot {\n  margin: 0;\n}\n.list-select-mtr > .list .select-item .v-messages {\n  display: none;\n}", ""]);

// exports
